// Mixins
import Vue from 'vue';
import {debounce} from "lodash";
import {SEARCH_CUSTOMER_RETURNING_EXTRA_DETAIL} from "../../graphql/queries/Customers";
/**
 * searchCustomer
 * @mixin
 *
 * Used to add search customer functionality to components
 * Looks for change in "searchCustomer" to automatically re-fetch
 */

export default Vue.extend({
    name: 'searchCustomer',
    apollo: {
        customers: {
            query: SEARCH_CUSTOMER_RETURNING_EXTRA_DETAIL,
            variables() {
                return {search: '%' + this.filterCustomer + '%'}
            }
        },
    },
    data(){
        return{
            customers: [],
            selectedCustomer: null,
            searchCustomer: null,
            filterCustomer: null,
        }
    },
    watch: {
        searchCustomer: debounce(function (val) {
            if (val?.length > 1) this.filterCustomer = val
        }, 500),
    },

});